import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/twoFactorAuth'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ValidationBoundary } from '@/components/validation'
import { localized } from '@/decorators/localized'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ToggleTwoFactor } from './toggleTwoFactor'
import { AuthenticatorForm } from './authenticatorForm'
import { PreferredMethodSelector } from './preferredMethodSelector'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'

@localized()
class TwoFactorSetupDialog extends React.Component {
  componentDidMount () {
    this.props.getTwoFactorInfo()
  }
  testCode = () => {
    openTwoFactorDialog(() => this.props.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Security.TestCode',
      content: 'Security.CodeIsOk'
    }))
  }
  configureAuthenticator = () => {
    openTwoFactorDialog(() => this.props.configureAuthenticator())
  }
  showAuthenticatorConfiguration = () => {
    openTwoFactorDialog(() => this.props.getAuthenticatorDetails())
  }
  removeAuthenticatorConfiguration = () => {
    openTwoFactorDialog(() => this.props.removeAuthenticatorConfiguration())
  }
  renderBody = () => {
    const loading = this.props.twoFactorAuth.fetching || !this.props.twoFactorAuth.twoFactor || this.props.twoFactorAuth.toggling
    if (loading) { return <LoadingIndicator /> }

    const { isTwoFactorRequired, isTwoFactorRequiredByPolicy } = this.props.twoFactorAuth.twoFactor
    const isRequired = isTwoFactorRequired || isTwoFactorRequiredByPolicy
    return (
      <React.Fragment>
        <ToggleTwoFactor localize={this.props.localize} isTwoFactorRequired={isTwoFactorRequired} isTwoFactorRequiredByPolicy={isTwoFactorRequiredByPolicy} toggleTwoFactorAuthentication={this.props.toggleTwoFactorAuthentication} testCode={this.testCode} />
        {isRequired && <PreferredMethodSelector localize={this.props.localize} {...this.props.twoFactorAuth} updateProvider={this.props.updatePreferredTwoFactorProvider} />}
        {isRequired && <AuthenticatorForm localize={this.props.localize} {...this.props.twoFactorAuth}
          configureAuthenticator={this.configureAuthenticator}
          showAuthenticatorConfiguration={this.showAuthenticatorConfiguration}
          removeAuthenticatorConfiguration={this.removeAuthenticatorConfiguration} />}
      </React.Fragment>
    )
  }
  render () {
    return (
      <ValidationBoundary>
        <BasicHeader title='Security:TwoFactorAuthentication' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            {this.renderBody()}
          </ErrorBoundary>
        </ModalBody>
      </ValidationBoundary>
    )
  }
}

function mapStateToProps (state) {
  return {
    twoFactorAuth: state.twoFactorAuth
  }
}

const mapDispatchToProps = {
  getTwoFactorInfo: actionCreators.getTwoFactorInfo,
  configureAuthenticator: actionCreators.configureAuthenticator,
  removeAuthenticatorConfiguration: actionCreators.removeAuthenticatorConfiguration,
  getAuthenticatorDetails: actionCreators.getAuthenticatorDetails,
  toggleTwoFactorAuthentication: actionCreators.toggleTwoFactorAuthentication,
  updatePreferredTwoFactorProvider: actionCreators.updatePreferredTwoFactorProvider,
  openDialog: dialogActions.openDialog
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(TwoFactorSetupDialog),
  modalProps: { size: 'lg' }
}



// WEBPACK FOOTER //
// ./src/dialogs/twoFactorSetup/index.js